module.exports = __webpack_public_path__ + "img/frame02_current.ddc93f28.png";